import { CreateChatSection } from '../section/section';

// @vue/component
export const AppearanceSection = {
	components: { CreateChatSection },
	data()
	{
		return {};
	},
	template: `
		<Section name="appearance" title="Appearance" />
	`,
};
